import React from "react";
import { IconArrowLeftSvg as StyledIconArrowLeftSvg } from "../styled";

const IconArrowLeftSvg = () => (
  <StyledIconArrowLeftSvg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_44_4049)">
      <path
        d="M3.2826 10.9395C2.69682 11.5252 2.69682 12.475 3.2826 13.0608L8.93946 18.7176C9.52524 19.3034 10.475 19.3034 11.0608 18.7176C11.6466 18.1318 11.6466 17.1821 11.0608 16.5963L7.96458 13.5001H19.5C20.3284 13.5001 21 12.8285 21 12.0001C21 11.1717 20.3284 10.5001 19.5 10.5001H7.96458L11.0608 7.40392C11.6466 6.81814 11.6466 5.86839 11.0608 5.2826C10.475 4.69682 9.52524 4.69682 8.93946 5.2826L3.2826 10.9395Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_44_4049">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </StyledIconArrowLeftSvg>
);

export default IconArrowLeftSvg;
